export const GLASGOW_SCORE = {
  masterTableName: "MC_GLASGOW_SCALE",
  tableName: "MC_GLASGOW_SCALE_DET",
  columnName: "GS_ID",
  columnValue: 0,
  title: "glasgow.glasgow-score",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
      type: "date",
    },
    {
      title: "see",
      value: "SEE_XNAME",
    },
    {
      title: "see_score",
      value: "SEE_SCORE",
    },
    {
      title: "verbal",
      value: "VERBAL_XNAME",
    },
    {
      title: "verbal_score",
      value: "VERBAL_SCORE",
    },
    {
      title: "motor",
      value: "MOTOR_XNAME",
    },
    {
      title: "motor_score",
      value: "MOTOR_SCORE",
    },
    {
      title: "glasgow",
      value: "GLASGOW_SCORE",
    },
    {
      title: "note",
      value: "NURSE_NOTE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "see", headerName: "glasgow.eye-open", flex: 1 },
    { field: "verbal", headerName: "glasgow.verbal-response", flex: 1 },
    { field: "motor", headerName: "glasgow.motor-response", flex: 1 },
    {
      field: "glasgow",
      headerName: "score",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        // tabloda dinamik hesaplanan yerler varsa gridde göstermek için computed: true yapın ve calculate fonksiyonu yazın
        const seeScore = Number(row.see_score) || 0;
        const verbalScore = Number(row.verbal_score) || 0;
        const motorScore = Number(row.motor_score) || 0;
        return seeScore + verbalScore + motorScore;
      },
    },
    { field: "note", headerName: "note", flex: 1 },
  ],
  mcpConfig: {
    SEE: { mcpId: 350, field: "SEE", scoreField: "SEE_SCORE" },
    VERBAL: { mcpId: 351, field: "VERBAL", scoreField: "VERBAL_SCORE" },
    MOTOR: { mcpId: 352, field: "MOTOR", scoreField: "MOTOR_SCORE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    GS_ID: "",
    PROCESS_TIME: new Date(),
    NURSE_ID: "",
    CTIME: new Date(),
    CUSER: "",
    NURSE_NOTE: "",
    SEE: "",
    SEE_SCORE: "",
    VERBAL: "",
    VERBAL_SCORE: "",
    MOTOR: "",
    MOTOR_SCORE: "",
    GLASGOW_SCORE: 0,
  },
  chartScoreField: "GLASGOW_SCORE", // Chart'ta gösterilecek skor alanı
  chartTimeField: "PROCESS_TIME", // Zaman bazında sıralama için kullanılacak alan
};
